// zh.js
module.exports = {
    "column": {
        "home": "首頁",
        "gallery": "在地人帶妳去",
        "blog": "體驗活動",
        "menu": "活動價目表",
        "about": "關於女巫",
        "news":"最新消息",
        "how": "如何到基隆",
        "getNews" :"想收到最新活動消息",
        "subscribe": "訂閱",
        "findUs": "找到我們"
      },
      "text": {
        "search": "搜尋"
      },
      "about":{
          "name":"女巫國際背包客插旗駐點",
          "describe":"女巫國際背包客生活體驗館隱藏在基隆最美海岸線上，與當地漁村生活共融，想一窺生活在最美海岸的女巫?\n且讓我們繼續看下去...",
          "about":"關於女巫"
      },
      "footer":{
        "found_us":"找到我們",
        "address":"202 基隆市中正區北寧路369巷21號",
        "news":"最新消息",
        "event":"                今年兒童節最夯的玩法 就是來基隆參加童話藝術節 \n**********************************\n我們在海洋廣場、陽明海洋文化藝術館、市民廣場、文化廣場\n有繽紛的市集、奇幻禮物盒、精采的表演\n紙風車的大型氣球、雙層巴士的巨型扭蛋機\n還有YOYO家族的哥哥姐姐們\n**********************************\n歡迎拔拔媽媽帶著孩子一起來基隆\n參加2019基隆童話藝術節 一起來嗨翻基隆\n",
        "detail":"詳細資訊"
      },
      "hello": {
        "welcome1": "Welcome to ",
        "welcome2": "基隆 KEELUNG",
      }
    }



//////////////////
// WEBPACK FOOTER
// ./static/lang/zh.js
// module id = z8sE
// module chunks = 1